var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardIconModCat16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38867 2V5C9.38867 5.41484 9.71185 5.75 10.1113 5.75H13V12.5C13 13.3273 12.3523 13.9999 11.5557 14H4.44434C3.64768 13.9999 3 13.3273 3 12.5V3.5C3 2.67269 3.64768 2.00006 4.44434 2H9.38867ZM5.33398 10.667C4.9659 10.667 4.66717 10.965 4.66699 11.333C4.66699 11.7012 4.96579 12 5.33398 12H7.33398C7.70187 11.9996 8 11.701 8 11.333C7.99982 10.9652 7.70177 10.6673 7.33398 10.667H5.33398ZM5.33398 8.66699C4.9659 8.66699 4.66717 8.96497 4.66699 9.33301C4.66699 9.7012 4.96579 10 5.33398 10H9.33398C9.70187 9.99965 10 9.70098 10 9.33301C9.99982 8.96518 9.70177 8.66734 9.33398 8.66699H5.33398ZM6 2.66699C5.26377 2.66717 4.66699 3.26373 4.66699 4C4.66699 4.73627 5.26377 5.33283 6 5.33301C6.73623 5.33283 7.33398 4.73627 7.33398 4C7.33398 3.26373 6.73623 2.66717 6 2.66699ZM13 5H10.1113V2L13 5Z",
    fill: "#00858A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardIconModCat16);
export default __webpack_public_path__ + "static/media/Board_icon_mod_cat_16.6f90647005a5aed2530b7895fb6d29a2.svg";
export { ForwardRef as ReactComponent };